
// States
const state = {
    errors: {}
};

// Getters
const getters = {
    errors: state => {
        return state.errors
    }
};

// Actions
const actions = {
    record(context,payload){
        context.commit('recordHandler', { errors: payload.errors });
    },

    clearErrorField(context,payload){
        context.commit('clearErrorFieldHandler', { field: payload.field });
    },
    /**
     * Determine if an errors exists for the given field.
     *
     * @param {string} field
     */
    has(context,payload) {
        return state.errors.hasOwnProperty(payload.field);
    },
    /**
     * Determine if we have any errors.
     */
    any() {
        return Object.keys(state.errors).length > 0;
    },
    /**
     * Retrieve the error message for a field.
     *
     * @param {string} field
     */
    get(context,payload) {
        if (state.errors[payload.field]) {
            return (state.errors[payload.field][0]);
        }
    }

};
// Mutations
const mutations = {
    /**
     * Record the new errors.
     *
     * @param {object} errors
     */
    recordHandler(state,{errors}) {
        state.errors = errors;
    },
    /**
     * Clear one or all error fields.
     *
     * @param {string|null} field
     */
    clearErrorFieldHandler(state,{field}) {
        if (field) {
            delete state.errors[field];
            return;
        }

        state.errors = {};
    }
}


export default {
    state,
    getters,
    actions,
    mutations,
}
